import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-curve-shape",
  "use": "icon-curve-shape-usage",
  "viewBox": "0 0 1459 587",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1459 587\" id=\"icon-curve-shape\"><path class=\"st0\" d=\"M1459 530.4c-103.3 18.3-251.4 19.8-251.4 19.8-166.4 3.3-336.9-14-336.9-14 67.3 11.7 182.1 28.1 330.8 32 149.1 4 257.6-9.7 257.6-9.7v22.8s-126.6 13.9-375.7-1.9C812.9 562.3 626.9 491.6 415 450.1 196 407.2 0 419.2 0 419.2V0h1459v530.4zM0 437.9s75.2-9.6 192.4-1.5c102.9 7.1 205.6 29.1 205.6 29.1s-96.1-12.7-206.5-13.6C80.9 450.9 0 461.4 0 461.4v-23.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol